import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

@Component({
    selector: "tab-config",
    templateUrl: "./tab-config.view.html",
    providers: []
})
export class TabConfigView implements OnInit {
    tabStyles: any = [
        {
            label: "Tab",
            code: "tab"
        },
        {
            label: "Underline",
            code: "underline"
        }
    ];
    borderStyles: any = [
        {
            label: "Thick Color Underline",
            code: "solid"
        },
        {
            label: "Dashed Color Underline",
            code: "dashed"
        },
        {
            label: "Dotted Color Underline",
            code: "dotted"
        }
    ];

    constructor(public sharedService: SharedService) {
        this.sharedService.tabsConfig.customCss = this.sharedService.beautifyCSS(
            this.sharedService.tabsConfig.customCss
        );
    }

    ngOnInit() {}
}
